<template>
  <v-card>
    <v-card-title style="text-align:center;" class="pb-0 mb-0">
      <h3 style="width:100%" class="headline mb-0">
        <v-icon large color="primary darken-1" class="mb-3">{{ icon }}</v-icon><br/>
        {{ $t('search.types.' + searchType) }}
      </h3>
    </v-card-title>
    <v-card-text>
      {{ $t('search.descriptions.' + searchType) }}
    </v-card-text>
    <v-card-actions>
      <v-btn block color="primary"
             :to="{ name: 'search', params: { searchType } }">
        <span class="sr-only">{{ $t('global.goTo') }}</span>
        {{ $t('search.types.' + searchType) }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    searchType: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
  /* these card styles are to help keep the actions/button at the bottom regardless of row height */
  .v-card__text {
    padding-bottom: 64px;
  }
  .v-card__actions {
    position: absolute;
    bottom: 0;
    width: 100%;
  }
</style>
